import { Outlet } from "react-router-dom";

export default function ScenarioCreator() {
    return (
        <div style={{ width: "100%", height: "90vh", margin: 0, padding: 0, overflowY: 'hidden' }}>
            <Outlet />
        </div>
    );
}
